"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleForm = exports.SimpleFormFieldTypes = exports.AutoCompleteInput = exports.SelectionInput = exports.CheckBoxInput = exports.TextAreaInput = exports.NumberInput = exports.EmailInput = exports.PasswordInput = exports.TextInput = exports.GenericInput = exports.FormGridDirection = exports.FormSize = exports.FormLayout = void 0;
var React = require("react");
var utils_1 = require("../../utils");
var Autosuggest = require("react-autosuggest");
var FormLayout;
(function (FormLayout) {
    FormLayout[FormLayout["VERTICAL"] = 0] = "VERTICAL";
    FormLayout[FormLayout["HORIZONTAL"] = 1] = "HORIZONTAL";
})(FormLayout = exports.FormLayout || (exports.FormLayout = {}));
var FormSize;
(function (FormSize) {
    FormSize["NORMAL"] = "";
    FormSize["SMALL"] = "sm";
    FormSize["LARGE"] = "lg";
})(FormSize = exports.FormSize || (exports.FormSize = {}));
var FormGridDirection;
(function (FormGridDirection) {
    FormGridDirection[FormGridDirection["LEFT_RIGHT"] = 0] = "LEFT_RIGHT";
    FormGridDirection[FormGridDirection["TOP_DOWN"] = 1] = "TOP_DOWN";
})(FormGridDirection = exports.FormGridDirection || (exports.FormGridDirection = {}));
function label_format(fmt) {
    var format = Object.assign({}, fmt);
    format.label_col = Math.min(format.label_col || 2, 8);
    format.label_class = format.label_class || "";
    if (format.form_layout == FormLayout.HORIZONTAL) {
        var size_append = format.label_size == FormSize.NORMAL
            ? format.label_size
            : "-" + format.label_size;
        format.label_class +=
            " col-form-label" + size_append + " col-" + format.label_col;
    }
    return format;
}
function input_format(fmt) {
    var format = Object.assign({}, fmt);
    format.input_col = format.input_col || 12 - format.label_col;
    var size_append = format.input_size == FormSize.NORMAL
        ? format.input_size
        : "-" + format.label_size;
    format.input_class =
        (format.input_class || "") + " form-control form-control" + size_append;
    return format;
}
function form_format(fmt) {
    var format = Object.assign({}, fmt);
    format.label_size = format.label_size || FormSize.NORMAL;
    format.input_size = format.input_size || FormSize.NORMAL;
    format.form_layout = format.form_layout || FormLayout.VERTICAL;
    format = label_format(format);
    format = input_format(format);
    if (format.form_layout == FormLayout.VERTICAL) {
        format.outer_class = (format.outer_class || "") + " form-group";
        format.inner_class = format.inner_class || "";
    }
    else {
        format.outer_class = (format.outer_class || "") + " form-group row";
        format.inner_class =
            (format.inner_class || "") + "col-" + format.input_col;
    }
    return format;
}
var GenericInput = function (props) {
    var _a = __read(React.useState((0, utils_1.uniqueId)("textinput-")), 1), html_id = _a[0];
    var format = form_format(props.format);
    return (React.createElement("div", { className: format.outer_class },
        React.createElement("label", { className: format.label_class +
                (props.required ? " required-label" : ""), htmlFor: html_id },
            props.label,
            ":"),
        React.createElement("div", { className: format.inner_class },
            React.createElement("input", { id: html_id, name: props.name, type: props.input_type, value: props.value, className: format.input_class, onChange: props.onChange, disabled: props.disabled }),
            props.help && (React.createElement("small", { className: "form-text text-muted" }, props.help)))));
};
exports.GenericInput = GenericInput;
var TextInput = function (props) {
    return React.createElement(exports.GenericInput, __assign({ input_type: "text" }, props));
};
exports.TextInput = TextInput;
var PasswordInput = function (props) {
    return React.createElement(exports.GenericInput, __assign({ input_type: "password" }, props));
};
exports.PasswordInput = PasswordInput;
var EmailInput = function (props) {
    return React.createElement(exports.GenericInput, __assign({ input_type: "email" }, props));
};
exports.EmailInput = EmailInput;
var NumberInput = function (props) {
    return React.createElement(exports.GenericInput, __assign({ input_type: "number" }, props));
};
exports.NumberInput = NumberInput;
var TextAreaInput = function (props) {
    var _a = __read(React.useState((0, utils_1.uniqueId)("textinput-")), 1), html_id = _a[0];
    var format = form_format(props.format);
    return (React.createElement("div", { className: format.outer_class },
        React.createElement("label", { htmlFor: html_id, className: format.label_class +
                (props.required ? " required-label" : "") },
            props.label,
            ":"),
        React.createElement("div", { className: format.inner_class },
            React.createElement("textarea", { id: html_id, name: props.name, onChange: props.onChange, className: format.input_class, rows: props.lines || 2, value: props.value, disabled: props.disabled }),
            props.help && (React.createElement("small", { className: "form-text text-muted" }, props.help)))));
};
exports.TextAreaInput = TextAreaInput;
var CheckBoxInput = function (props) {
    var _a = __read(React.useState((0, utils_1.uniqueId)("textinput-")), 1), html_id = _a[0];
    var format = form_format(props.format);
    function handleCheckboxChange(e) {
        var name = e.target.name;
        var value = e.target.checked;
        props.onUpdate(name, value);
    }
    return (React.createElement("div", { className: format.outer_class },
        React.createElement("label", { className: format.label_class +
                (props.required ? " required-label" : ""), htmlFor: html_id }, props.label),
        React.createElement("div", { className: format.inner_class + " custom-control custom-switch", style: { paddingLeft: "45px", paddingTop: "8px" } },
            React.createElement("input", { id: html_id, name: props.name, type: "checkbox", checked: props.value, className: "custom-control-input", onChange: handleCheckboxChange, disabled: props.disabled }),
            React.createElement("label", { className: "custom-control-label", htmlFor: html_id }))));
};
exports.CheckBoxInput = CheckBoxInput;
var SelectionInput = function (props) {
    var _a = __read(React.useState((0, utils_1.uniqueId)("select-")), 1), html_id = _a[0];
    var options = props.options || [];
    var format = form_format(props.format);
    return (React.createElement("div", { className: format.outer_class },
        React.createElement("label", { htmlFor: html_id, className: format.label_class +
                (props.required ? " required-label" : "") },
            props.label,
            ":"),
        React.createElement("div", { className: format.inner_class },
            React.createElement("select", { id: html_id, name: props.name, value: props.value, onChange: props.onChange, className: format.input_class, disabled: props.disabled }, options.map(function (option) { return (React.createElement("option", { key: option[0], value: option[0] }, option[1])); })),
            props.help && (React.createElement("small", { className: "form-text text-muted" }, props.help)))));
};
exports.SelectionInput = SelectionInput;
var AutoCompleteInput = function (props) {
    var _a = __read(React.useState((0, utils_1.uniqueId)("autosuggest-")), 1), html_id = _a[0];
    var _b = __read(React.useState(""), 2), inputValue = _b[0], setInputValue = _b[1];
    var _c = __read(React.useState([]), 2), inputOptions = _c[0], setInputOptions = _c[1];
    var format = form_format(props.format);
    var resetFromValue = function (value) {
        var selected = props.options.filter(function (option) { return option[0] == props.value; });
        if (selected.length > 0)
            setInputValue(selected[0][1]);
    };
    React.useEffect(function () {
        resetFromValue(props.value);
        setInputOptions(props.options);
    }, [props.value, props.options]);
    return (React.createElement("div", { className: format.outer_class },
        React.createElement("label", { htmlFor: html_id, className: format.label_class +
                (props.required ? " required-label" : "") },
            props.label,
            ":"),
        React.createElement("div", { className: format.inner_class },
            React.createElement(Autosuggest, { suggestions: inputOptions, shouldRenderSuggestions: function () { return true; }, renderSuggestion: function (option) { return (React.createElement("span", null, option[1])); }, getSuggestionValue: function (option) {
                    return option[1];
                }, onSuggestionsFetchRequested: function (data) {
                    return setInputOptions(props.options.filter(function (option) {
                        return option[1].indexOf(data.value) != -1;
                    }));
                }, onSuggestionsClearRequested: function () {
                    return setInputOptions(props.options);
                }, onSuggestionSelected: function (event, data) {
                    props.onUpdate(props.name, data.suggestion[0]);
                }, inputProps: {
                    value: inputValue,
                    id: html_id,
                    onChange: function (event, params) {
                        setInputValue(params.newValue);
                    },
                    onBlur: function () { return resetFromValue(props.value); },
                    className: format.input_class,
                } }),
            props.help && (React.createElement("small", { className: "form-text text-muted" }, props.help)))));
};
exports.AutoCompleteInput = AutoCompleteInput;
var SimpleFormFieldTypes = (function () {
    function SimpleFormFieldTypes() {
    }
    SimpleFormFieldTypes.TEXT = "text";
    SimpleFormFieldTypes.PASSWORD = "password";
    SimpleFormFieldTypes.EMAIL = "email";
    SimpleFormFieldTypes.TEXTAREA = "textarea";
    SimpleFormFieldTypes.SELECT = "select";
    SimpleFormFieldTypes.CHECK = "checkbox";
    SimpleFormFieldTypes.NUMBER = "number";
    SimpleFormFieldTypes.AUTOCOMPLETE = "autocomplete";
    return SimpleFormFieldTypes;
}());
exports.SimpleFormFieldTypes = SimpleFormFieldTypes;
var getFieldComponent = function (type) {
    switch (type) {
        case SimpleFormFieldTypes.TEXT:
            return exports.TextInput;
        case SimpleFormFieldTypes.PASSWORD:
            return exports.PasswordInput;
        case SimpleFormFieldTypes.EMAIL:
            return exports.EmailInput;
        case SimpleFormFieldTypes.TEXTAREA:
            return exports.TextAreaInput;
        case SimpleFormFieldTypes.SELECT:
            return exports.SelectionInput;
        case SimpleFormFieldTypes.AUTOCOMPLETE:
            return exports.AutoCompleteInput;
        case SimpleFormFieldTypes.CHECK:
            return exports.CheckBoxInput;
        case SimpleFormFieldTypes.NUMBER:
            return exports.NumberInput;
    }
};
var SimpleForm = function (props) {
    var handleFieldChange = function (e) {
        var name = e.target.name;
        var value = e.target.value;
        props.onUpdate(name, value);
    };
    var grid_columns = props.format
        ? props.format.form_grid_columns
        : undefined;
    var grid_direction = props.format
        ? props.format.form_grid_direction
        : FormGridDirection.LEFT_RIGHT;
    var field_components = props.fields
        .filter(function (field) { return Boolean(field); })
        .map(function (field) {
        var name = field.name, value = field.value, label = field.label, field_type = field.field_type, disabled = field.disabled, other = __rest(field, ["name", "value", "label", "field_type", "disabled"]);
        var FieldComponent = getFieldComponent(field_type);
        return (React.createElement(FieldComponent, __assign({ key: name, name: name, value: typeof value === "function"
                ? value(props.valuesObject)
                : value, label: label, disabled: disabled, format: props.format || { form_layout: FormLayout.VERTICAL }, onChange: handleFieldChange, onUpdate: props.onUpdate }, other)));
    });
    if (!grid_columns)
        return React.createElement.apply(React, __spreadArray([React.Fragment, null], __read(field_components), false));
    var col_size = Math.trunc(12 / grid_columns);
    var rows = Math.round(field_components.length / grid_columns);
    return (React.createElement(React.Fragment, null, __spreadArray([], __read(Array(rows).keys()), false).map(function (row) { return (React.createElement("div", { className: "form-row", key: row }, __spreadArray([], __read(Array(grid_columns).keys()), false).map(function (column) {
        var index = grid_direction == FormGridDirection.LEFT_RIGHT
            ? row * grid_columns + column
            : column * rows + row;
        return (React.createElement("div", { key: column, className: "col-" + col_size }, index < field_components.length
            ? field_components[index]
            : null));
    }))); })));
};
exports.SimpleForm = SimpleForm;
